<template>
  <vSelect
    :options="addresses"
    v-model="address"
    @search="search"
    :reduce="address => address"
    :filterable="false"
    :loading="loading"
    :required="required"
  >
    <template #no-options>
      <span v-if="loading">Завантаження...</span>
      <span v-else>{{ $filters.localize("select.noOptions") }}</span>
    </template>
  </vSelect>
</template>

<script>
import vSelect from "vue-select";
export default {
  name: "select-address",
  emits: ['update', "required"],
  props: { entity: Object },
  components: { vSelect },
  data() {
    return {
      addresses: [],
      loading: false,
      searchTimeout: null,
      requestId: 0,
      abortController: null,
    };
  },
  computed: {
    address: {
      get() {
        return this.entity.address;
      },
      set(value) {
        this.$emit("update", value);
      }
    }
  },
  methods: {
    search(name) {
      const value = name?.trim();
      window.clearTimeout(this.searchTimeout);

      if (!value || !this.entity.city) {
        this.addresses = [];
        this.cancelRequest();
        return;
      }

      this.searchTimeout = window.setTimeout(() => this.loadAddresses(value), 300);
    },
    async loadAddresses(name) {
      const requestId = ++this.requestId;
      this.cancelRequest();
      const controller = new AbortController();
      this.abortController = controller;
      this.loading = true;

      try {
        const result = await this.$store.dispatch('getAPI', { controller: "address", method: `warehouses/${this.entity.city}/${name}`, signal: controller.signal });
        if (requestId === this.requestId) {
          this.addresses = result.data.data.map(x => this.map(x));
        }
      } catch (error) {
        if (error.code !== "ERR_CANCELED") {
          throw error;
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
          this.abortController = null;
        }
      }
    },
    cancelRequest() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    },
    map(data) {
      return data.description;
    },
  },
  beforeUnmount() {
    window.clearTimeout(this.searchTimeout);
    this.cancelRequest();
  },
};
</script>
